import { render, staticRenderFns } from "./vod_rails_landscape.vue?vue&type=template&id=1d12956b&scoped=true&"
import script from "./vod_rails_landscape.vue?vue&type=script&lang=js&"
export * from "./vod_rails_landscape.vue?vue&type=script&lang=js&"
import style0 from "./vod_rails_landscape.vue?vue&type=style&index=0&id=1d12956b&scoped=true&lang=css&"
import style1 from "./vod_rails_landscape.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12956b",
  null
  
)

export default component.exports